import request from '@/utils/request'

// 获取菜单列表
export function getMenuList() {
  return request({
    url: '/menu/list',
    method: 'get'
  })
}

// 获取菜单树结构（需要管理员权限）
export function getMenuTree() {
  return request({
    url: '/menu/tree',
    method: 'get'
  })
}

// 获取当前登录用户的菜单树（普通用户可用）
export function getCurrentUserMenu() {
  return request({
    url: '/menu/current',
    method: 'get'
  })
}

// 根据用户ID获取菜单树
export function getUserMenuTree(userId) {
  return request({
    url: `/menu/user/${userId}`,
    method: 'get'
  })
}

// 获取菜单详情
export function getMenuInfo(menuId) {
  return request({
    url: `/menu/${menuId}`,
    method: 'get'
  })
}

// 创建菜单
export function createMenu(data) {
  return request({
    url: '/menu',
    method: 'post',
    data
  })
}

// 更新菜单
export function updateMenu(data) {
  return request({
    url: '/menu',
    method: 'put',
    data
  })
}

// 删除菜单
export function deleteMenu(menuId) {
  return request({
    url: `/menu/${menuId}`,
    method: 'delete'
  })
}

// 批量删除菜单
export function deleteMenus(menuIds) {
  return request({
    url: '/menu',
    method: 'delete',
    data: menuIds
  })
}

// 更新菜单状态
export function updateMenuStatus(menuId, status) {
  return request({
    url: '/menu/status',
    method: 'put',
    params: { menuId, status }
  })
}

// 检查菜单名称唯一性
export function checkMenuNameUnique(menuName, parentId, excludeMenuId) {
  return request({
    url: '/menu/check-name-unique',
    method: 'get',
    params: { menuName, parentId, excludeMenuId }
  })
}

// 根据角色ID获取菜单列表
export function getMenusByRoleId(roleId) {
  return request({
    url: `/menu/role/${roleId}`,
    method: 'get'
  })
}

// 批量更新菜单排序
export function updateMenuOrders(data) {
  return request({
    url: '/menu/order',
    method: 'put',
    data
  })
}